import "core-js/modules/es.string.trim.js";
import "core-js/modules/es.array.iterator.js";
import { lodash } from '@isyc-react/core/lodash';
import convert from 'color-convert';
const cssRgbSuffix = '-rgb';
const cssHueSuffix = '-hue';
const cssSaturationSuffix = '-saturation';
export const cssDeclarations = [
// Fonts
{
  css: {
    var: '--font-general'
  },
  path: ['font', 'general']
}, {
  css: {
    var: '--font-headings'
  },
  path: ['font', 'headings']
}, {
  css: {
    var: '--font-headings-weight'
  },
  path: ['font', 'headingsWeight']
}, {
  css: {
    var: '--font-size'
  },
  path: ['font', 'size']
},
// Primary
{
  css: {
    var: '--primary-color-lighter'
  },
  path: ['primary', 'lighter']
}, {
  css: {
    var: '--primary-color-light'
  },
  path: ['primary', 'light']
}, {
  css: {
    var: '--primary-color',
    rgb: true,
    hue: true,
    saturation: true
  },
  path: ['primary', 'color']
}, {
  css: {
    var: '--primary-color-dark'
  },
  path: ['primary', 'dark']
}, {
  css: {
    var: '--primary-color-darker'
  },
  path: ['primary', 'darker']
}, {
  css: {
    var: '--primary-color-contrast-text'
  },
  path: ['primary', 'contrastText']
}, {
  css: {
    var: '--primary-color-hover',
    rgb: true
  },
  path: ['primary', 'hover']
}, {
  css: {
    var: '--primary-color-hover-contrast-text'
  },
  path: ['primary', 'hoverContrastText']
},
// Secondary
{
  css: {
    var: '--secondary-color-lighter'
  },
  path: ['secondary', 'lighter']
}, {
  css: {
    var: '--secondary-color-light'
  },
  path: ['secondary', 'light']
}, {
  css: {
    var: '--secondary-color',
    rgb: true,
    hue: true,
    saturation: true
  },
  path: ['secondary', 'color']
}, {
  css: {
    var: '--secondary-color-dark'
  },
  path: ['secondary', 'dark']
}, {
  css: {
    var: '--secondary-color-darker'
  },
  path: ['secondary', 'darker']
}, {
  css: {
    var: '--secondary-color-contrast-text'
  },
  path: ['secondary', 'contrastText']
}, {
  css: {
    var: '--secondary-color-hover',
    rgb: true
  },
  path: ['secondary', 'hover']
}, {
  css: {
    var: '--secondary-color-hover-contrast-text'
  },
  path: ['secondary', 'hoverContrastText']
},
// Tertiary
{
  css: {
    var: '--tertiary-color-lighter'
  },
  path: ['tertiary', 'lighter']
}, {
  css: {
    var: '--tertiary-color-light'
  },
  path: ['tertiary', 'light']
}, {
  css: {
    var: '--tertiary-color',
    rgb: true,
    hue: true,
    saturation: true
  },
  path: ['tertiary', 'color']
}, {
  css: {
    var: '--tertiary-color-dark'
  },
  path: ['tertiary', 'dark']
}, {
  css: {
    var: '--tertiary-color-darker'
  },
  path: ['tertiary', 'darker']
}, {
  css: {
    var: '--tertiary-color-contrast-text'
  },
  path: ['tertiary', 'contrastText']
}, {
  css: {
    var: '--tertiary-color-hover',
    rgb: true
  },
  path: ['tertiary', 'hover']
}, {
  css: {
    var: '--tertiary-color-hover-contrast-text'
  },
  path: ['tertiary', 'hoverContrastText']
},
// Danger
{
  css: {
    var: '--danger-color',
    rgb: true
  },
  path: ['danger', 'color']
},
// Buttons
{
  css: {
    var: '--button-radius'
  },
  path: ['buttons', 'radius']
}

// TODO form radius,border size, heights ...
];
const varRgb = variable => variable + cssRgbSuffix;
const varHue = variable => variable + cssHueSuffix;
const varSaturation = variable => variable + cssSaturationSuffix;
const varGetter = (element, variable) => getComputedStyle(element).getPropertyValue(variable).trim();
const varRemove = (element, variable) => element.style.removeProperty(variable);
const varSetter = (element, variable, property) => element.style.setProperty(variable, property);
const cssGetter = declaration => element => varGetter(element, declaration.var);
const cssRemove = declaration => element => {
  varRemove(element, declaration.var);
  if (declaration.rgb) varRemove(element, varRgb(declaration.var));
  if (declaration.hue) varRemove(element, varHue(declaration.var));
  if (declaration.saturation) varRemove(element, varSaturation(declaration.var));
};
const cssSetter = declaration => (element, property) => {
  varSetter(element, declaration.var, property);
  if (declaration.rgb) {
    const rgb = convert.hex.rgb(property);
    varSetter(element, varRgb(declaration.var), rgb.join(','));
  }
  if (declaration.hue || declaration.saturation) {
    const hsl = convert.hex.hsl(property);
    declaration.hue && varSetter(element, varHue(declaration.var), hsl[0].toString());
    declaration.saturation && varSetter(element, varSaturation(declaration.var), `${hsl[1]}%`);
  }
};
const themeGetter = (...path) => theme => lodash.get(theme, path, '');
const themeSetter = (...path) => (theme, property) => lodash.set(theme, path, property);
export const cssVariables = cssDeclarations.map(d => ({
  css: d.css,
  path: d.path,
  themeGetter: themeGetter(...d.path),
  themeSetter: themeSetter(...d.path),
  cssGetter: cssGetter(d.css),
  cssSetter: cssSetter(d.css),
  cssRemove: cssRemove(d.css)
}));